module.exports = "/default/fonts/vendor/lightgallery.js/dist/lg.ttf?4fe6f9caff8b287170d51d3d71d5e5c6";